import { handleGetFormDesignWidgetName } from '../render/util';
export const getWidgetVxeUploadImageConfig = () => {
    return {
        title: handleGetFormDesignWidgetName,
        icon: 'vxe-icon-file-image',
        options: {
            limitCount: 9,
            limitSize: 10,
            multiple: false
        }
    };
};
